import Card from 'components/card';
import { MdOutlineCall, MdOutlineEdit, MdOutlineEmail } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const statutLabels: Record<string, string> = {
    actif: 'Client actif',
    prospect: 'Prospect',
    perdu: 'Perdu',
    liquidation: 'Liquidation',
    autre: 'Autre',
};

const statutColors: Record<string, string> = {
    actif: 'bg-green-100 text-green-800',
    prospect: 'bg-blue-100 text-blue-800',
    perdu: 'bg-red-100 text-red-800',
    liquidation: 'bg-gray-200 text-gray-700',
    autre: 'bg-purple-100 text-purple-800',
};

const CustomerInfoPreview = (props: { customer: any }) => {
    const { customer } = props;
    const navigate = useNavigate();

    return (
        <Card extra={'w-full !p-5 border col-span-12 sm:col-span-6 relative'}>
            {/* Header */}
            <div
                id="edit-customer"
                className="absolute top-5 right-5 hover:cursor-pointer"
                onClick={() => navigate(`/edit-customer/${customer?._id}`)}
            >
                <MdOutlineEdit />
            </div>
            <div className="flex w-full px-[8px] items-center flex-wrap gap-2">
                <h4 className="text-lg font-medium text-navy-700 dark:text-white">
                    {customer && customer.displayName}{' '}
                </h4>
                <p className="my-auto text-xs">
                    {customer ? `${customer.company}` : ' - Fiche client'}
                </p>
                {customer?.statut && (
                    <span
                        className={`text-[10px] font-medium px-2 py-[3px] rounded-xl ${statutColors[customer.statut] || statutColors.actif}`}
                    >
                        {statutLabels[customer.statut] || statutLabels.actif}
                    </span>
                )}
                {customer?.isBlocked && (
                    <span className="text-[10px] font-medium px-2 py-[3px] rounded-xl bg-red-600 text-white">
                        Bloqué
                    </span>
                )}
            </div>
            {customer?.statut === 'perdu' && customer?.raisonPerte && (
                <p className="px-[8px] mt-1 text-xs text-red-700">
                    Raison de la perte : {customer.raisonPerte}
                </p>
            )}
            {customer?.isBlocked && customer?.blockedReason && (
                <p className="px-[8px] mt-1 text-xs text-red-700">
                    Raison du blocage : {customer.blockedReason}
                </p>
            )}
            <div className="text-sm sm:flex gap-5 my-auto">
                <div className="mt-2 sm:mt-0 flex gap-2">
                    <MdOutlineCall className="my-auto" size={20} />
                    <div>
                        <p className="text-sm font-medium">
                            Numéro de téléphone
                        </p>
                        <p className="text-xs">
                            {customer && customer.phone
                                ? customer.phone
                                : '+33- -- -- -- --'}
                        </p>
                        {customer && customer.phone2 && (
                            <p className="text-xs mt-1">
                                {customer.phone2}
                            </p>
                        )}
                    </div>
                </div>
                <div className="mt-5 sm:mt-0 flex gap-2">
                    <MdOutlineEmail className="my-auto" size={20} />
                    <div>
                        <p className="text-sm font-medium">Adresse mail</p>
                        <p className="text-xs">{customer?.mail}</p>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default CustomerInfoPreview;
